module.exports = __webpack_public_path__ + "static/img/phone.9efc3a01.png";